import { getCall } from '../../utils/apiCalls'
import { GET_ETM_TRIPS, GET_ETM_ROUTES } from '../../config/urls'
import {
  ETM_TICKETS_TRIP_LIST,
  ETM_TICKET_DETAILS,
  CLEAR_TICKET_DETAILS,
  CLEAR_ALL_ETM_TICKETS_DATA,
  UPDATE_ETM_USER_INPUT_VALUES,
  ETM_ROUTES_LIST
} from './actionTypes'

export const getTripsDetails = (query) => dispatch => {
  getCall(GET_ETM_TRIPS, query)
    .then(res => {
      if(res.status !== 200) {
        alert(res.response.data.message || 'Error Occurred, please try later');
        return;
      }
      dispatch({
        type: ETM_TICKETS_TRIP_LIST,
        payload: { data: res.data.tripDetailsList || [] },
      })
    })
}

export const getTicketDetails = (tripId) => dispatch => {
  getCall(`${GET_ETM_TRIPS}/${tripId}`)
    .then(res => {
      if(res.status !== 200) {
        alert(res.response.data.message || 'Error Occurred, please try later');
        return;
      }
      dispatch({
        type: ETM_TICKET_DETAILS,
        payload: { data: res.data.ticketMetaInfo || [] },
      })
    })
}

export const getETMRoutes = () => dispatch => {
  getCall(GET_ETM_ROUTES)
    .then(res => {
      if(res.status !== 200) {
        alert(((res.response || {}).data || {}).message || 'Error Occurred, please try later');
        return;
      }
      dispatch({
        type: ETM_ROUTES_LIST,
        payload: { data: res.data || {} },
      })
    })
}

export const clearTicketDetails = () => ({
  type: CLEAR_TICKET_DETAILS
})

export const updateInputValues = data => ({
  type: UPDATE_ETM_USER_INPUT_VALUES,
  payload: data
})

export const clearAllData = () => ({
  type: CLEAR_ALL_ETM_TICKETS_DATA
})

